import React from 'react'
import BasePostFactory from './_BasePostFactory'

export const PageFactory = ({ renderers = {} } = {}) => {
  const BasePost = BasePostFactory({ renderers })

  const Page = props => (
    <BasePost
      {...props}
      contentType="page"
      defaultWhich="home"
      extraFields={['hideTitle']}
      fields={{
        image: 'featuredImage',
        date: null,
      }}
    />
  )

  return Page
}

export default PageFactory()
